import { render, staticRenderFns } from "./DashboardTodos.vue?vue&type=template&id=f2c5da9c&scoped=true&"
import script from "./DashboardTodos.vue?vue&type=script&setup=true&lang=js&"
export * from "./DashboardTodos.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DashboardTodos.vue?vue&type=style&index=0&id=f2c5da9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c5da9c",
  null
  
)

export default component.exports